import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mv-poles-layout',
  templateUrl: './mv-poles-layout.component.html',
  styleUrls: ['./mv-poles-layout.component.scss']
})
export class MvPolesLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
